import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=8837c62e&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=8837c62e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8837c62e",
  null
  
)

export default component.exports